<template>
  <div class="auth-shell auth-shell--centered">
    <div class="auth-card">
      <div class="auth-card__logo">
        <img :src="logoPath" alt="logo" />
      </div>
      <div class="auth-card__heading">
        <h3>{{ $t("pages.login.description") }}</h3>
        <h5>{{ $t("pages.reset_password.init_session") }}</h5>
      </div>

      <form @submit.prevent="recoverPassword" class="auth-card__panel">
        <div class="alert alert-danger" role="alert" v-if="error">
          {{ error }}
        </div>

        <name-field :form="form" name="name" id="name" />

        <div class="text-center">
          <vue-button
            :title="$t('pages.reset_password.reset_now')"
            :loading="isLoading"
            class="btn btn-primary btn-block p-3 text-uppercase"
            type="submit"
          />
        </div>
      </form>

      <div class="auth-card__footer-link">
        <router-link :to="{ name: 'login' }">{{
          $t("pages.reset_password.login_return")
        }}</router-link>
      </div>
      <div class="auth-card__copyright">
        {{ copyright }}
      </div>
      <div class="auth-card__stores">
        <google-play-badge class="mr-3" />
        <apple-store-badge />
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api/user";

import { mapGetters } from "vuex";
import { VueButton, Form } from "@/components/form";
import { RequiredRule } from "@/components/form/data/rules";
import { NameField } from "@/pages/auth/fields";
import * as Sentry from "@sentry/vue";
import { ModalAlert } from "@/components/modal";

import { AppleStoreBadge, GooglePlayBadge } from "@/components";

export default {
  layout: "BasicLayout",
  middleware: "auth",
  components: {
    VueButton,
    NameField,
    AppleStoreBadge,
    GooglePlayBadge,
  },
  data() {
    return {
      error: null,
      form: new Form({
        data: {
          name: null,
        },
      }),
      isLoading: false,
    };
  },
  computed: {
    ...mapGetters("app", ["appVersion", "logoPath", "copyright"]),
    ...mapGetters("auth", ["logoPath"]),
    fieldsRules() {
      return [
        new RequiredRule({
          name: "name",
          errorMessage: this.$t("components.fields.rules.required"),
        }),
      ];
    },
  },
  methods: {
    clear() {
      this.form.reset();
      this.form.clear();
    },
    async recoverPassword() {
      this.form.setFieldsRules(this.fieldsRules);

      if (this.form.validate()) {
        this.isLoading = true;
        this.error = "";
        const data = this.form.data();

        Sentry.setContext("recoverData", {
          name: data.name,
        });

        api
          .recoverPassword(data)
          .then(async () => {
            this.clear();
            ModalAlert.success({
              title: this.$t("pages.reset_password.init_session"),
              message: this.$t("pages.reset_password.reset_password_message_info"),
            });
          })
          .catch((error) => {
            if (error.message.toLowerCase() === "network error") {
              this.error = this.$t("components.messages.network_error");
            } else if (error.response) {
              if (error.response.status === 404) {
                this.error = this.$t("auth.user_not_found");
                this.clear();
              } else {
                //unsigned error
                Sentry.captureException(error);
                this.error = this.$t("components.messages.error");
              }
            } else {
              //unsigned error
              Sentry.captureException(error);
              this.error = this.$t("components.messages.error");
            }
          })
          .then(() => {
            this.isLoading = false;
          });
      }
    },
  },
};
</script>
